var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1634 0.344108C13.1077 0.378882 11.1158 2.32925 8.73704 4.67819C6.35829 7.02718 4.39688 8.94907 4.37833 8.94907C4.35978 8.94907 3.55387 8.17008 2.58746 7.21795C0.666186 5.32516 0.728967 5.37627 0.419118 5.45325C0.239324 5.49793 0.049934 5.6924 0.0168541 5.86634C-0.038831 6.15923 -0.0810677 6.11042 2.05747 8.22389C3.14752 9.30114 4.0875 10.2051 4.1463 10.2326C4.28149 10.2959 4.50632 10.2969 4.62482 10.2348C4.675 10.2085 6.78661 8.14187 9.31723 5.64223C14.3496 0.671642 14.0543 0.98664 13.9628 0.685212C13.8823 0.419991 13.6915 0.280495 13.4095 0.280762C13.3258 0.280829 13.2221 0.307534 13.1634 0.344108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default __webpack_public_path__ + "static/media/rightTick.ed8f8eddfc0bdc85f63297c4232934a8.svg";
export { ForwardRef as ReactComponent };